import { SupportedLocale } from "@/i18n";
import { Bibliography } from "../types";
import { computeFieldLongSummaryBibliographie } from "../computeFields";

/** Periodic notices: use stored résumé when manually overridden, else derive from live fields. */
export function resolveBibliographieResumeLong(
  bibliography: Bibliography | null | undefined,
  language: SupportedLocale,
): string {
  if (!bibliography) return "";
  const stored = bibliography.bibliographieDescriptionResumeLong ?? "";
  const nomRevue = bibliography.bibliographieDescriptionNomRevue?.trim();
  if (nomRevue) {
    const computed = computeFieldLongSummaryBibliographie(bibliography, {
      language,
    });
    if (stored.trim() && stored !== computed) return stored;
    return computed || stored;
  }
  return stored;
}
